<template>
    <v-layout column mb-4>
        <v-tabs
            slot="extension"
            color="white"
            slider-color="#e2173d"
            class="mb-5 tabs-mobile"
        >
            <v-tab
                v-for="(filter, idx) in filters"
                :key="filter.name"
                class="wrapper-relative" @click="changeTab(idx)"
            >
                <v-layout row wrap align-center>
                    <v-flex md2>
                        <svg v-svg
                             :symbol="filter.image"
                             size="32 32"
                             class="icon"
                             role="presentation"
                        />
                    </v-flex>
                    <v-flex sm12 xs12 md9
                            :class="{'pl-0': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                    >
                        {{ $t(filter.text) }}
                    </v-flex>
                    <v-flex class="md1 study__badge">
                        <v-badge :color="filter.color">
                            <span slot="badge">{{ courses_number[filter.name] }}</span>
                        </v-badge>
                    </v-flex>
                </v-layout>
            </v-tab>
        </v-tabs>
        <h2 v-if="selected_filter && $vuetify.breakpoint.mdAndUp" class="section-title mt-3 ml-0">
            {{ $t(selected_filter.text) }}
        </h2>

        <div
            class="study-blocks-wrapper" :class="{ 'study-blocks-wrapper--is-grid': onlyBusinessPlus }"
        >

          <div
            v-for="(filtered, index) in displayedCards"
            :id="'id'+filtered.id"
            :key="filtered.id"
        >
            <StudyCard
                :id="filtered.id"
                :card_number="index"
                :isScorm="filtered.is_scorm"
                :scormPath="filtered.scorm_path"
                :isBusinessPlus="filtered.is_business_plus"
                :isDisabled="filtered.is_disabled"
            >
                {{ filtered.title }}
            </StudyCard>
            <!-- <div v-if="cards.length==0">{{$t("Курсы не найдены")}}</div>  -->
        </div>

        </div>
    </v-layout>
</template>

<script>
import StudyCard from '@/components/view_blocks/Study/Study_card.vue';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  name      : 'StudyCards',
  components: {
    StudyCard,
  },
  props: {
    onlyBusinessPlus: {
      type   : Boolean,
      default: false,
    },
  },
  data: () => ({
  }),
  computed: {
    ...mapGetters('cards', ['cards', 'filters', 'filtered_cards', 'selected_filter', 'courses_number']),

    displayedCards() {
      if (!this.cards || this.cards.length === 0) return [];

      let filtered = this.filtered_cards;

      if (this.onlyBusinessPlus) {
        return filtered.filter((card) => card.is_business_plus);
      } else {
        return filtered.filter((card) => !card.is_business_plus);
      }
    },

  },
  created() {
    this.SELECT_FILTER(0);
  },
  async mounted() {
    this.LOADING_ON();
    await this.get_courses();
    if (this.onlyBusinessPlus) {
      await this.courses_count_business_plus();
    } else {
      await this.courses_count();
    }
    await this.get_load_user();
    this.LOADING_OFF();
  },
  methods: {
    ...mapMutations('common', ['LOADING_ON', 'LOADING_OFF']),
    ...mapMutations('cards', ['SELECT_FILTER']),
    ...mapActions('cards', ['get_courses', 'courses_count', 'courses_count_business_plus']),
    async changeTab(idx) {
      this.LOADING_ON();
      this.SELECT_FILTER(idx);
      await this.get_courses();
      this.LOADING_OFF();
    },
    ...mapActions('autorisation', [
      'get_load_user',
    ]),
  },
};
</script>
